/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Layout from "../../layout";
import Bots from "./features/bots";

const ManageBots = () => {
  return (
    <>
      <Layout>
        <section className="main_area">
          <Bots />
        </section>
      </Layout>
    </>
  );
};
export default ManageBots;
